import axios from 'axios'

export default{
    namespaced: true,

    state: {
        reportPeriods: []
    },

    getters: {
        getReportPeriods(state){
            return state.reportPeriods;
        }
    },

    mutations: {
        setReportPeriods(state, value){
            state.reportPeriods = value;
        }
    },

    actions: {
        getReportTerms({ rootGetters }){
            const url = `/api/report-card-terms?student_id=${rootGetters['auth/getUserID']}`;              
            return axios.get(url);
        }
    },
}